import React, { useState } from 'react';

export default function InputTip({ tip, children }) {
    const [isFocused, setIsFocused] = useState(false);

    // Clone the child element (e.g., <input>) to attach onFocus/onBlur handlers
    // while preserving any existing handlers passed to the child.
    const inputWithHandlers = React.cloneElement(children, {
        onFocus: (e) => {
            setIsFocused(true);
            if (children.props.onFocus) children.props.onFocus(e);
        },
        onBlur: (e) => {
            setIsFocused(false);
            if (children.props.onBlur) children.props.onBlur(e);
        }
    });

    return (
        <div style={{ position: 'relative' }}>
            {isFocused && (
                <div style={{
                    position: 'absolute',
                    bottom: '100%',
                    left: '0',
                    marginBottom: '8px',
                    backgroundColor: '#fff',
                    border: '1px solid #dee2e6',
                    borderRadius: '4px',
                    padding: '6px 12px',
                    fontSize: '13px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                    zIndex: 10,
                    color: '#555',
                    whiteSpace: 'nowrap'
                }}>
                    {tip}
                    {/* Triangle border */}
                    <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: '15px',
                        borderWidth: '6px',
                        borderStyle: 'solid',
                        borderColor: '#dee2e6 transparent transparent transparent'
                    }} />
                    {/* Triangle fill to mask border */}
                    <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: '15px',
                        borderWidth: '6px',
                        borderStyle: 'solid',
                        borderColor: '#fff transparent transparent transparent',
                        marginTop: '-1.5px'
                    }} />
                </div>
            )}
            {inputWithHandlers}
        </div>
    );
}
